export enum PayWallExperiment {
  show_paywall_first = "show_paywall_first",
  show_paywall_last = "show_paywall_last",
}

export const getExperimentForPaywall = (currentOrgId: number) => {
  if (currentOrgId % 2 === 0) {
    return PayWallExperiment.show_paywall_last;
  } else {
    return PayWallExperiment.show_paywall_first;
  }
};

export const checkoutFromExperiment = (currentOrgId: number) => {
  localStorage.setItem(`paywall_experiment_${currentOrgId}`, "true");
};

export const isFromExperiment = (currentOrgId: number) => {
  return localStorage.getItem(`paywall_experiment_${currentOrgId}`) === "true";
};
